import React from 'react';
import { TcsmVideoBlock } from '../../models/tcsm-block-models';
import { ContentSpacer } from '../layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';


interface Props {
    blockData: TcsmVideoBlock,
}

export function TcsmVideoBlockView(props: Props) {

    const { blockData } = props;

    function RenderVideo() {
        if (blockData.videoUrl && blockData.videoContentType) {
            return (
                <div className="adage-video-native">
                    <video controls poster={blockData.thumbnail}>
                        <source src={blockData.videoUrl} type={blockData.videoContentType} />
                    </video>
                </div>);
        }
    }

    function RenderVimeoVideo() {
        if (blockData.vimeoId) {
            return (
                <div className="adage-video-iframe">
                    <iframe width="640" height="360" src={`https://player.vimeo.com/video/${blockData.vimeoId}`} frameBorder="0" allowFullScreen title={blockData.vimeoId}></iframe>
                </div>);
        }
    }

    function RenderYoutubeVideo() {
        if (blockData.youTubeId) {
            return (
                <div className="adage-video-iframe">
                    <iframe width="640" height="360" src={`https://www.youtube.com/embed/${blockData.youTubeId}?rel=0&showinfo=0`} frameBorder="0" allowFullScreen title={blockData.youTubeId}></iframe>
                </div>);
        }
    }

    return (
        <section className="adage-block">
            <ContentSpacer>
                <h2>{blockData?.pageTitle}</h2>
            </ContentSpacer>
            <ContentSpacer>
                <WysiwygWithReactLink content={blockData?.captionWysiwyg} />
            </ContentSpacer>
            <figure className=" adage-video-block">
                {RenderVideo()}
                {RenderVimeoVideo()}
                {RenderYoutubeVideo()}
            </figure>
        </section>
    );
}

export default TcsmVideoBlockView;
